import React, {useState} from "react";
import "./Main.css";

import MapContainer from "./MapContainer";
import Searchbar from "./Searchbar";

const Main = () => {
  const [selectedPortofLoading, setSelectedPortofLoading] = useState(null);
  const [selectedPortofDischarge, setSelectedPortofDischarge] = useState(null);
  const [showModalSelectPort, setShowModalSelectPort] = useState(false);
  const [portType, setPortType] = useState("");
  const [isSelectingDestination, setIsSelectingDestination] = useState(false);

  const handleSelectPort = (port) => {
    if (portType === "loading") {
      setSelectedPortofLoading(port);
      setSelectedPortofDischarge(null); // Reset Zielhafen bei neuem Ladehafen
    } else if (portType === "discharge") {
      setSelectedPortofDischarge(port);
    }
    setShowModalSelectPort(false);
  };

  const handleSelectLoadingPort = (port) => {
    setSelectedPortofLoading(port);
    setSelectedPortofDischarge(null);
  };

  const handleSelectDischargePort = (port) => {
    setSelectedPortofDischarge(port);
  };

  const handleShowModalSelectPort = (type) => {
    setPortType(type);

    // WICHTIG: Setze isSelectingDestination basierend auf dem portType
    if (type === "discharge") {
      setIsSelectingDestination(true); // Wir wählen einen Zielhafen
    } else {
      setIsSelectingDestination(false); // Wir wählen einen Starthafen
    }

    setShowModalSelectPort(true);
  };

  const handleCloseModalSelectPort = () => {
    setShowModalSelectPort(false);
    console.log("Modal geschlossen");
    console.log("Ladehafen:", selectedPortofLoading);
  };

  return (
    <div className="main-container">
      {/* Karte Container */}
      <MapContainer
        selectedPortofLoading={selectedPortofLoading}
        selectedPortofDischarge={selectedPortofDischarge}
        setSelectedPortofLoading={setSelectedPortofLoading}
        setSelectedPortofDischarge={setSelectedPortofDischarge}
        handleSelectPort={handleSelectPort}
      />

      {/* Such-Komponente */}
      <Searchbar
        selectedPortofLoading={selectedPortofLoading}
        handleSelectPort={handleSelectPort}
        handleSelectLoadingPort={handleSelectLoadingPort}
        handleSelectDischargePort={handleSelectDischargePort}
        selectedPortofDischarge={selectedPortofDischarge}
        handleCloseModalSelectPort={handleCloseModalSelectPort}
        showModalSelectPort={showModalSelectPort}
        handleShowModalSelectPort={handleShowModalSelectPort}
        isSelectingDestination={isSelectingDestination}
      />
      {/* <div>
        <h4>Ausgewählter Hafen des Ladens:</h4>
        {selectedPortofLoading ? (
          <p>
            {selectedPortofLoading.name} in {selectedPortofLoading.country}
          </p>
        ) : (
          <p>Kein Hafen ausgewählt</p>
        )}
        <h4>Ausgewählter Hafen des Entladens:</h4>
        {selectedPortofDischarge ? (
          <p>
            {selectedPortofDischarge.name} in {selectedPortofDischarge.country}
          </p>
        ) : (
          <p>Kein Hafen ausgewählt</p>
        )}
        <h4>IsSelectingDestination: {isSelectingDestination.toString()}</h4>
        <h4>HafenTyp: {portType}</h4>
      </div> */}
    </div>
  );
};

export default Main;
